import React, { useState, useRef, useEffect } from 'react';
import AboutPage from "../../pages/AboutPage";
import ReferencePage from "../../pages/ReferencePage";
import ContactPage from "../../pages/ContactPage";
import PrivacyPage from "../../pages/PrivacyPage";
import { useTranslation } from 'react-i18next';

const LANGUAGES = [
  { code: 'tr', label: 'Türkçe',     flag: '/flags/tr.svg' },
  { code: 'en', label: 'English',    flag: '/flags/en.svg' },
  { code: 'az', label: 'Azərbaycan', flag: '/flags/az.svg' },
  { code: 'es', label: 'Español',    flag: '/flags/es.svg' },
  { code: 'fr', label: 'Français',   flag: '/flags/fr.svg' },
  { code: 'kk', label: 'Қазақша',    flag: '/flags/kk.svg' },
  { code: 'ky', label: 'Кыргызча',   flag: '/flags/ky.svg' },
  { code: 'ru', label: 'Русский',    flag: '/flags/ru.svg' },
  { code: 'uz', label: "O‘zbekcha",  flag: '/flags/uz.svg' },
  { code: 'ar', label: 'العربية',    flag: '/flags/arab.svg' },
];

const Footer = () => {
  const [isAboutOpen, setIsAboutOpen]         = useState(false);
  const [isReferencesOpen, setIsReferencesOpen] = useState(false);
  const [isContactOpen, setIsContactOpen]       = useState(false);
  const [isPrivacyOpen, setIsPrivacyOpen]       = useState(false);
  const { t, i18n } = useTranslation();

  const [langMenuOpen, setLangMenuOpen] = useState(false);
  const menuRef = useRef(null);

  // Menü dışına tıklayınca kapat
  useEffect(() => {
    const onClickOutside = e => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setLangMenuOpen(false);
      }
    };
    document.addEventListener('mousedown', onClickOutside);
    return () => document.removeEventListener('mousedown', onClickOutside);
  }, []);

  const changeLang = (lng) => {
    i18n.changeLanguage(lng);
    setLangMenuOpen(false);
  };

  const activeLang = LANGUAGES.find(l => l.code === i18n.resolvedLanguage) || LANGUAGES[1];

  return (
    <>
      <footer className="bg-[#3c4f58] text-white py-3 fixed bottom-0 w-full">
        <div className="container mx-auto px-4 flex justify-between items-center">

          {/* Menü Butonları */}
          <div className="flex-1 flex justify-around">
            <button onClick={() => setIsAboutOpen(true)}        className="hover:text-gray-300">
              {t('Piri AI Nedir?')}
            </button>
            <button onClick={() => setIsReferencesOpen(true)}  className="hover:text-gray-300">
              {t('Referanslar')}
            </button>
            <button onClick={() => setIsContactOpen(true)}     className="hover:text-gray-300">
              {t('İletişim')}
            </button>
            <button onClick={() => setIsPrivacyOpen(true)}     className="hover:text-gray-300">
              {t('Gizlilik ve Güvenlik')}
            </button>
          </div>

          {/* Dil Seçici (drop-up) */}
          <div className="relative" ref={menuRef}>
            <button
              onClick={() => setLangMenuOpen(open => !open)}
              className="p-1 border border-white rounded hover:border-gray-200 transition-colors"
            >
              <img
                src={activeLang.flag}
                alt={activeLang.label}
                title={activeLang.label}
                className="w-6 h-4"
              />
            </button>

            {langMenuOpen && (
              <div className="absolute right-0 bottom-full mb-2 w-32 bg-white rounded shadow-lg z-10">
                {LANGUAGES.map(({ code, label, flag }) => (
                  <div
                    key={code}
                    onClick={() => changeLang(code)}
                    className="flex items-center px-2 py-1 hover:bg-gray-100 cursor-pointer"
                  >
                    <img src={flag} alt={label} className="w-5 h-3 mr-2" />
                    <span className="text-sm text-gray-700">{label}</span>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </footer>

      {/* Modaller */}
      <AboutPage isOpen={isAboutOpen} onClose={() => setIsAboutOpen(false)} />
      <ReferencePage isOpen={isReferencesOpen} onClose={() => setIsReferencesOpen(false)} />
      <ContactPage   isOpen={isContactOpen}   onClose={() => setIsContactOpen(false)} />
      <PrivacyPage   isOpen={isPrivacyOpen}   onClose={() => setIsPrivacyOpen(false)} />
    </>
  );
};

export default Footer;
